import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/service/user.service';
import { EmpInsurance } from 'src/app/shared/models/EmpInsurance';
import { MatDialog, MatTableDataSource, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { EmployeeService } from 'src/app/shared/service/employee.service';
import { HrEmpFamilyDetail } from 'src/app/shared/models/hrEmpFamilyDetail';
import { hrEmpPersonalDetails } from 'src/app/shared/models/hrEmpPersonalDetails';
import { BasicEmployeeDetails } from 'src/app/shared/models/basicemployeedetails.model';

import { isUndefined, debug } from 'util';
import { isNullOrUndefined } from 'util';
import { EmpRelation } from 'src/app/shared/models/EmpRelation';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { concat } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import * as moment from 'moment';
import { AppConfig } from '../../app.config';
export const MY_FORMATS = {

  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-employee-insurance',
  templateUrl: './employee-insurance.component.html',
  styleUrls: ['./employee-insurance.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EmployeeInsuranceComponent implements OnInit {
  @Input() LoginEmpCode: any;
  EmpInsuranceform: FormGroup;
 // insuranceDetails: EmpInsurance;
  @Output('employeeDet') employeeDet = new EventEmitter();
  @Output('familyDet') familyDet = new EventEmitter();
  @Output('insuranceDet') insuranceDet = new EventEmitter();
  insurance: EmpInsurance;
  age: number;
  empCode: number;
  personalDetails: any;
  empPersonalDetailList: hrEmpPersonalDetails;
  dataSourceFTE: MatTableDataSource<HrEmpFamilyDetail>
  dataSourceParents: MatTableDataSource<HrEmpFamilyDetail>
  // Father: OnboardEmpFamilyDetail = new OnboardEmpFamilyDetail();
  //Mother: OnboardEmpFamilyDetail = new OnboardEmpFamilyDetail();
  //Spouse: OnboardEmpFamilyDetail = new OnboardEmpFamilyDetail();
  children: HrEmpFamilyDetail[] = [];
  //FamilyDetails: HrEmpFamilyDetail[] = [];
  PersonalDetform: FormGroup;
  error: string;
  premiumYearList: any;
  sumAssuredList: any[];
  parentsSumAssuredList: any[];
  numberOfParents: number=0;
  familyInsurance: HrEmpFamilyDetail[]=[];
  empinsurances: HrEmpFamilyDetail[] = [];
  insuranceArray: EmpInsurance;
  bool: Boolean;
  empinsurance: HrEmpFamilyDetail;
  relation: EmpRelation[]=[];
  checked: boolean = true;
  d1: any;
  d2: any;
    disableSumAssuredParents: boolean;
    empDOJ: any;
    premiumYearListData: any;
    noOfDaysCalc: any;
    dayscalcdiff: number;
    empDetails: BasicEmployeeDetails;
    hideParentAccordion: boolean=false;
    employeeDateofJoining: Date;
  changeValue(value) {
    this.checked = !value;
  }
  ReadOnlyStyleGuideNotes: boolean;
  Child1: any;
  employee: any;
  Child2: any;
  Father: any;
  Mother: any;
  Spouse: any;
  HREmp: BasicEmployeeDetails;
  employeeDetails: BasicEmployeeDetails;
  FamilyDetails: HrEmpFamilyDetail[]=[];
  FamilyInsuranceDetails: EmpInsurance[]=[];
  optionArray: any[] = [];
  premiumYearId: number;
  varSelfPremium: number;
  totalSelfPremium: number;
  totalParentsPremium: number;
  varParentsPremium: number;
  selfPloicyNumbers: number=1;
  premiumValue: number = 130000;
  totalSumAssuredVal: number ;
  companyContribution: number ;
  balance: number;
  parentCount: any;
  countParents: number = 0;
  sumAssuredParentsRequired: boolean;
  todayDate: Date;
  empFamilyDetailsInsuranceOptions: any[] = [];
  constructor(private userService: UserService, private config: AppConfig, private empSvc: EmployeeService, OnformBuilder: FormBuilder, public toastr: ToastrService, public dialog: MatDialog, private fb: FormBuilder) {
    this.dataSourceFTE = new MatTableDataSource;
    this.dataSourceParents = new MatTableDataSource;
    this.todayDate = new Date();
  }
  displayedColumns: string[] = ['Relation', 'Name', 'DOB', 'Age', 'IncludeInsurance'];
  displayedColumnsParents: string[] = ['Relation', 'Name', 'DOB', 'Age', 'IncludeInsurance'];


  ngOnInit() {
    //this.getSumAssuredList();
    this.LoadForm();
   // this.relation = new EmpRelation();
  }
  LoadForm() {
    this.LoginEmpCode = this.userService.getEmpCode();
    this.employeeDateofJoining = this.userService.getdOJ();
    this.insurance = new EmpInsurance();
    this.todayDate = new Date();
    this.FormInitialization();

    this.personalDetails = new hrEmpPersonalDetails();
    this.insuranceArray = new EmpInsurance();
    this.ReadOnlyStyleGuideNotes = true;
    this.HREmp = new BasicEmployeeDetails();
    if (!isUndefined(this.LoginEmpCode)) {
      this.getDOJEmployeebyCode();
      this.getAllEmpRelations();
      this.getPremiumYearList();
      this.getSumAssuredList();
      //this.getEmployeeDetails();
      //this.getInsuranceDetails();
      //this.getAllEmpRelations();
    }

    this.employeeDetails = new BasicEmployeeDetails();
    this.dataSourceFTE = new MatTableDataSource;
    this.dataSourceParents = new MatTableDataSource;
    this.dataSourceFTE.data = this.FamilyDetails;
    this.empinsurance = new HrEmpFamilyDetail();
  }
  ResetData() {
    location.reload();
  }
  FormInitialization() {
    this.EmpInsuranceform = new FormGroup({
      NamePerRecords: new FormControl(),
      DOB: new FormControl(),
      Age: new FormControl(),
      DOJ:new FormControl(),
      SelfSumAssured: new FormControl(),
      ParentsSumAssured: new FormControl(),
      PremiumYearId:new FormControl(),
      selfPremium: new FormControl(),
      parentsPremium: new FormControl(),
      membersCount: new FormControl(),
      membersCountSelf:new FormControl()
   

    });
  }


  // convenience getter for easy access to form fields
  get f() { return this.EmpInsuranceform.controls; }

  getAllEmpRelations() {
    this.empSvc.getAllEmpRelations().subscribe((data: EmpRelation[]) => {
      this.relation = data;
    },
      error => this.error = error   )
  }
  
  getDOJEmployeebyCode() {
    this.empSvc.getBasicEmployeeById(this.LoginEmpCode).subscribe((data: BasicEmployeeDetails) => {
      this.empDetails = data;
      //this.insuranceArray.DOJ = this.empDetails.DOJ;
      this.empDOJ = this.empDetails.DOJ;
    }, error => this.toastr.warning(error))
  }
  getPremiumYearList() {
    this.empSvc.GetInsurancePermium().subscribe((data: any) => {
      if (isNullOrUndefined(this.premiumYearId) || this.premiumYearId == 0) {
        this.premiumYearId = data.find(x => x.IsActive == true).Id;
        this.premiumYearListData = data.find(x => x.IsActive == true);
        this.companyContribution = this.premiumYearListData.CompanyContribution;
        this.d1 = moment(this.premiumYearListData.ToDate);
        this.d2 = moment(this.employeeDateofJoining);
        if (this.employeeDateofJoining >= this.premiumYearListData.FromDate) {
          this.dayscalcdiff = Math.abs(this.d1.diff(this.d2, 'days')) +1;

          //this.noOfDaysCalc = this.dayscalcdiff / (1000 * 60 * 60 * 24);
        }
        else {
          this.dayscalcdiff = 365;
        }

        
      }
      this.premiumYearList = data;
      this.getInsuranceDetails();
    });
  }
  getSumAssuredList() {
    this.empSvc.getInsuranceSumAssureds().subscribe((data: any) => {
      
      this.sumAssuredList = data.filter(x => x.PremiumYearId == this.premiumYearId && x.PolicyTypeId == 1);
      this.parentsSumAssuredList = data.filter(x => x.PremiumYearId == this.premiumYearId && x.PolicyTypeId == 2);
    });
  }
  getInsuranceDetails() {
    this.dataSourceFTE = new MatTableDataSource;
    this.dataSourceParents = new MatTableDataSource;

    this.empCode = this.LoginEmpCode;
    this.empinsurances = [];    
    this.empSvc.getInsuranceDetails(this.empCode,this.premiumYearId).subscribe((data: EmpInsurance) => {
      if (data != null) {
        //if (this.todayDate == this.config.cutOffDateInsurance) {
        //  data.IsSubmit = true;
        //}
        this.insuranceArray = data;
        this.totalSelfPremium = this.insuranceArray.SelfPremium;
        this.totalParentsPremium = this.insuranceArray.ParentsPremium;
        this.totalSumAssuredVal = this.insuranceArray.TotalPremium;
        const selfelogindetails = new HrEmpFamilyDetail();
        this.calculateAge(this.insuranceArray.DOB);
        
        selfelogindetails.Name = data.NameAsPerRecords;
        selfelogindetails.RelationName = 'Self';
        selfelogindetails.Age = this.insuranceArray.Age;
        selfelogindetails.DOB = this.insuranceArray.DOB;
        selfelogindetails.IncludeInsurance = true;
        this.empinsurances.push(selfelogindetails);
        if (this.insuranceArray.IsSubmit == true) {
          this.empFamilyDetailsInsuranceOptions = data.employeeFamilyDetailsonSubmit;
         
        }
        else if (this.insuranceArray.IsSubmit == false || isNullOrUndefined(this.insuranceArray)) {
          this.FamilyDetails = data.employeeFamilyDetails;
          this.empFamilyDetailsInsuranceOptions = this.FamilyDetails;
        }
      
        for (var i = 0; i < this.empFamilyDetailsInsuranceOptions.length; i++) {
          this.empFamilyDetailsInsuranceOptions[i].RelationName = this.relation.find(x => x.RelationId == this.empFamilyDetailsInsuranceOptions[i].RelationId).RelationName;
          if (this.insuranceArray.IsSubmit == true) {
            this.empFamilyDetailsInsuranceOptions[i].Name = this.empFamilyDetailsInsuranceOptions[i].FamilyMemberName;
            this.empFamilyDetailsInsuranceOptions[i].DOB = this.empFamilyDetailsInsuranceOptions[i].FamilyMemberDOB;
            this.empFamilyDetailsInsuranceOptions[i].Age = this.empFamilyDetailsInsuranceOptions[i].FamilyMemberAge;
          }
          this.empinsurances.push(this.empFamilyDetailsInsuranceOptions[i]);
        }
        this.selfPloicyNumbers = this.empinsurances.filter(e => e.IncludeInsurance === true && (e.RelationName != "Father" && e.RelationName != "Mother")).length;

        this.numberOfParents = this.empinsurances.filter(e => e.IncludeInsurance === true && (e.RelationName === "Father" || e.RelationName === "Mother")).length;
        if (this.numberOfParents == 0) {
          this.disableSumAssuredParents = true;
          this.sumAssuredParentsRequired = false;
        }
        else {
          this.disableSumAssuredParents = false;
          this.sumAssuredParentsRequired = true;
        }
   var tempdatasource= this.empinsurances.filter(x => x.RelationName != 'Father' && x.RelationName!='Mother');
        var tempdatasourceparents=this.empinsurances.filter(x => x.RelationName == 'Father' || x.RelationName == 'Mother');
        this.dataSourceFTE.data = tempdatasource;
        this.dataSourceParents.data = tempdatasourceparents;
        if (isNullOrUndefined(this.insuranceArray.PremiumYearId) || this.insuranceArray.PremiumYearId ==0) {
          this.insuranceArray.PremiumYearId = this.premiumYearId;
        }
        if (tempdatasourceparents.length == 0) {
          this.hideParentAccordion = true;
        }
        this.numberOfParents = this.empinsurances.filter(e => e.IncludeInsurance === true && (e.RelationName === "Father" || e.RelationName === "Mother")).length;
      }
      
      if (!this.totalSelfPremium) {
       this.totalSelfPremium = 0;
      }
      if (!this.totalParentsPremium) {
        this.totalParentsPremium = 0;
      }
      if (!this.totalSumAssuredVal) {
        this.totalSumAssuredVal = 0;
      }
      if (!this.balance) {
        this.balance = 0;
        this.balance = (Math.round(this.totalSumAssuredVal - this.companyContribution));
      }
    }
    )
    this.getSumAssuredList();
  }
  onSelfSumAssuredChange(val) {
    this.numberOfParents = this.empinsurances.filter(e => e.IncludeInsurance === true && (e.RelationName === "Father" || e.RelationName === "Mother")).length;
    this.varSelfPremium = this.sumAssuredList.find(x => x.SumAssured == val.value).Premium;
    this.totalSelfPremium = (Math.round((this.selfPloicyNumbers * this.varSelfPremium) * ((this.dayscalcdiff) / 365)));
    if (!isNullOrUndefined(this.insuranceArray.SumAssuredParents)) {

      this.varParentsPremium = this.parentsSumAssuredList.find(x => x.SumAssured == this.insuranceArray.SumAssuredParents).Premium;

    }
    else {
      this.varParentsPremium = 0;
    }
    this.totalParentsPremium =(Math.round((this.numberOfParents * this.varParentsPremium) * ((this.dayscalcdiff) / 365)));
    if (this.totalParentsPremium != 0 || this.totalParentsPremium) {
      this.totalSumAssuredVal = (Math.round(this.totalSelfPremium  + this.totalParentsPremium));
    }
    else if (this.totalParentsPremium == 0 || !this.totalParentsPremium) {

      this.totalSumAssuredVal =(Math.round( this.totalSelfPremium  + this.totalParentsPremium));
      //this.totalSumAssuredVal = this.totalSelfPremium  + this.totalParentsPremium ;


    }
    this.balance = (Math.round(this.totalSumAssuredVal - this.companyContribution)); 
    if (!this.totalSelfPremium) {
      this.totalSelfPremium = 0;
    }
    if (!this.totalParentsPremium) {
      this.totalParentsPremium = 0;
    }
    if (!this.totalSumAssuredVal) {
      this.totalSumAssuredVal = 0;
    }
    if (!this.balance) {
      this.balance = 0;
      this.balance = (Math.round(this.totalSumAssuredVal - this.companyContribution));
    }
  }
  onParentsSumAssuredChange(val) {
    if (!isNullOrUndefined(this.insuranceArray.SumAssured)) {

      this.varSelfPremium = this.sumAssuredList.find(x => x.SumAssured == this.insuranceArray.SumAssured).Premium;

    }
    else {
      this.varSelfPremium = 0;
    }
    this.varParentsPremium = this.parentsSumAssuredList.find(x => x.SumAssured == val.value).Premium;

    this.totalSelfPremium = (Math.round((this.selfPloicyNumbers * this.varSelfPremium) * ((this.dayscalcdiff) / 365)));
    this.totalParentsPremium = (Math.round((this.numberOfParents * this.varParentsPremium) * ((this.dayscalcdiff) / 365)));
    this.totalSumAssuredVal =(Math.round( this.totalSelfPremium  + this.totalParentsPremium ));
    this.balance = (Math.round(this.totalSumAssuredVal - this.companyContribution));
    if (!this.totalSelfPremium) {
      this.totalSelfPremium = 0;
    }
    if (!this.totalParentsPremium) {
      this.totalParentsPremium = 0;
    }
    if (!this.totalSumAssuredVal) {
      this.totalSumAssuredVal = 0;
    }
    if (!this.balance) {
      this.balance = 0;
      this.balance = (Math.round(this.totalSumAssuredVal - this.companyContribution));
    }
  }
  SaveInsuranceDetails() {
  
    // var basicDetails =  this.getBasicEmployeeDetailsById();
    // var communicationData = this.getCommunicationData();
    this.insuranceArray.EmpCode = this.userService.getEmpCode();
    this.insuranceArray.ModifiedBy = this.LoginEmpCode;
    //this.insuranceArray.employeeFamilyDetails = new HrEmpFamilyDetail;
    this.insuranceArray.employeeFamilyDetails = this.children;
    this.insuranceArray.employeeFamilyDetails = this.empinsurances;
    // this.insuranceArray.SumAssured = this.InsuranceDetails.SumAssured;
    this.insuranceArray.TotalPremium = this.totalSumAssuredVal;
    this.insuranceArray.SelfPremium = this.totalSelfPremium;
    this.insuranceArray.ParentsPremium = this.totalParentsPremium;
    for (var i = 0; i < this.insuranceArray.employeeFamilyDetails.length; i++) {
      if (isNullOrUndefined(this.insuranceArray.employeeFamilyDetails[i].IncludeInsurance)) {
        this.insuranceArray.employeeFamilyDetails[i].IncludeInsurance = false;
      }
    }
    //this.insuranceArray.FamilyMemberName = this.insuranceArray.employeeFamilyDetails.
    this.empSvc.SaveEmployeeInsurance(this.insuranceArray).subscribe((data: any) => {
      if (data.ErrorType == "Exception") {
        this.toastr.warning(data.ErrorMsg);
      }
      else {
        this.toastr.success("Saved Successfully");
      }
    }, error => this.toastr.warning(error));
  }

  SubmitInsuranceDetails() {
       
    if (this.insuranceArray === undefined || this.insuranceArray.PremiumYearId === undefined)
    {
      this.toastr.warning('Please Select Year');
      return false;
    }
    if (this.insuranceArray.SumAssured === null || this.insuranceArray.SumAssured === undefined) {
      this.toastr.warning('Please Select Coverage Amount for self');
      return false;
    }
    if (this.numberOfParents != 0) {
    if (this.insuranceArray.SumAssuredParents === null || this.insuranceArray.SumAssuredParents === undefined) {
      this.toastr.warning('Please Select Coverage Amount for parents');
      return false;
      }
    }
    // self employee checkbox need to checked is mandatory  start
    const selfempcheck = this.empinsurances.filter(x => x.IncludeInsurance == true && x.RelationName=="Self") 

    if (selfempcheck.length==0) {
      this.toastr.warning('Please Select Self Employee ');
       return false;
    }
    // self employee checkbox need to checked is mandatory End
    const selectecyear = this.premiumYearList.filter(x => x.Id == this.insuranceArray.PremiumYearId)[0].PremiumYear;
    const message = 'Are you sure you want to submit insurance details for this year (' + selectecyear + ')?' 
      var deleteType = "Submit";
      const dialogData = new ConfirmDialogModel(" ", message, deleteType);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult) {

          this.insuranceArray.EmpCode = this.userService.getEmpCode();
          this.insuranceArray.ModifiedBy = this.LoginEmpCode;
          this.insuranceArray.employeeFamilyDetails = this.empinsurances;
          this.insuranceArray.IsSubmit = true;
          this.insuranceArray.TotalPremium = this.totalSumAssuredVal;
          this.insuranceArray.SelfPremium = this.totalSelfPremium;
          this.insuranceArray.ParentsPremium = this.totalParentsPremium;
          for (var i = 0; i < this.insuranceArray.employeeFamilyDetails.length; i++) {
            if (isNullOrUndefined(this.insuranceArray.employeeFamilyDetails[i].IncludeInsurance)) {
              this.insuranceArray.employeeFamilyDetails[i].IncludeInsurance = false;
            }
          }
          this.empSvc.SaveEmployeeInsurance(this.insuranceArray).subscribe((data: any) => {
            if (data.ErrorType == "Exception") {
              this.toastr.warning(data.ErrorMsg);
            }
            else {
              alert("You have successfully exercised your options for group medical insurance. Please be informed that the total premium is Rs." + this.totalSumAssuredVal + ".");
              this.toastr.success("Saved Successfully");
            }
          }, error => this.toastr.warning(error));
        }
      });    
  }
  changeEvent(element: any, event: any, type: string) {
    //this.numberOfParents = this.empinsurances.filter(e => e.IncludeInsurance === element.IncludeInsurance && (e.RelationName === "Father" || e.RelationName === "Mother")).length;

    //if (this.numberOfParents==0) {
    //  this.disableSumAssuredParents = true;
    //  this.totalParentsPremium = 0;
    //  this.totalSumAssuredVal = this.totalSelfPremium * (this.dayscalcdiff) / 365 + this.totalParentsPremium * (this.dayscalcdiff) / 365;
    //  this.insuranceArray.SumAssuredParents = null;
    //}
    //else  {
    //  this.disableSumAssuredParents = false;
    //}
    this.countParents = this.numberOfParents;
    if (event.checked == true && type=="parents") {
      this.countParents++;
    }
    else if (event.checked == false && type == "parents") {
      this.countParents--;
    }
    if (this.countParents == 0 && type == "parents") {
      this.disableSumAssuredParents = true;
      this.insuranceArray.SumAssuredParents = null;
      this.sumAssuredParentsRequired = false;
    }
    else if (this.countParents != 0 && type == "parents") {
      this.disableSumAssuredParents = false;
      this.sumAssuredParentsRequired = true;
    }
    if (element.IncludeInsurance == null || element.IncludeInsurance == false) {
      this.totalParentsPremium = 0;
      this.totalSumAssuredVal = (Math.round(this.totalSelfPremium + this.totalParentsPremium));
      //element.IncludeInsurance = true;
      //this.empinsurance.IncludeInsurance = element;
      this.empinsurances.forEach(
        (item, index) => {
          if (item.ID == element.ID) {
            item.IncludeInsurance = true;
            //if (item.RelationName == "Father") {
            //  this.numberOfParents=++this.numberOfParents
            //}
            //if (item.RelationName == "Mother") {
            //  this.numberOfParents = ++this.numberOfParents
            //}
            //if (item.RelationName != "Mother" && item.RelationName != "Father") {
            //  this.selfPloicyNumbers = ++this.selfPloicyNumbers;
            //}
          }
        }
      )
    //  this.empinsurances.push(element);
    //  console.log(this.empinsurances);

    }
    //  this.employeeDetails.PermanentAddress = this.employeeDetails.TemporaryAddress;
    else if (element.IncludeInsurance==true) {
      this.empinsurances.forEach(
        (item, index) => {
          if (item.ID == element.ID) {
            item.IncludeInsurance = false;
          }
        }
      )
    }

    this.selfPloicyNumbers = this.empinsurances.filter(e => e.IncludeInsurance === true && (e.RelationName != "Father" && e.RelationName != "Mother")).length;
    if (!isNullOrUndefined(this.insuranceArray.SumAssured)) {

      this.varSelfPremium = this.sumAssuredList.find(x => x.SumAssured == this.insuranceArray.SumAssured).Premium;
    }
    else {
      this.varSelfPremium = 0;
    }
    if (!isNullOrUndefined(this.insuranceArray.SumAssuredParents)) {

      this.varParentsPremium = this.parentsSumAssuredList.find(x => x.SumAssured == this.insuranceArray.SumAssuredParents).Premium;
    }
    else { this.varParentsPremium = 0; }
    this.numberOfParents = this.empinsurances.filter(e => e.IncludeInsurance === true && (e.RelationName === "Father" || e.RelationName === "Mother")).length;
    if (this.numberOfParents == 0) {
      this.totalParentsPremium = 0;
    }
    else {
      this.totalParentsPremium = (Math.round((this.numberOfParents * this.varParentsPremium) * ((this.dayscalcdiff) / 365)));
    }
    //if (this.selfPloicyNumbers == 0) {
    //  this.totalSelfPremium = 0;
    //}
    //else {
    //  this.totalSelfPremium = this.selfPloicyNumbers * this.varSelfPremium;
    //}
    this.totalSelfPremium = (Math.round((this.selfPloicyNumbers * this.varSelfPremium) * ((this.dayscalcdiff) / 365)));
    this.totalSumAssuredVal = (Math.round(this.totalSelfPremium + this.totalParentsPremium));
    this.balance = (Math.round(this.totalSumAssuredVal - this.companyContribution ));
  }

  calculateAge(dob: Date) {

    var Dob = new Date(dob);
    for (var i = 0; i < this.premiumYearList.length; i++) {
      if (this.premiumYearId != null) {
        var insuranceDate = new Date(this.premiumYearList.find(x => x.Id == this.premiumYearId).FromDate);
      }
      else {
        var insuranceDate = new Date(this.premiumYearList.find(x => x.Id == this.insuranceArray.PremiumYearId).FromDate);

      }
                  
    }
    this.age = insuranceDate.getFullYear() - Dob.getFullYear();
    const months = insuranceDate.getMonth() - Dob.getMonth();
    if (months < 0 || (months === 0 && insuranceDate.getDate() < Dob.getDate())) {
        this.age--;
    }
    this.insuranceArray.Age = this.age;
    }

  onPremiumYearChange(premium) {
    this.premiumYearId = premium.value;
    this.LoadForm();
  }
}
